import { createElement, Fragment } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { toggleFormat } from '@wordpress/rich-text';
import { RichTextToolbarButton, RichTextShortcut, __unstableRichTextInputEvent } from '@wordpress/block-editor';
import { formatItalic } from '@wordpress/icons';
const name = 'core/italic';

const title = __('Italic');

export const italic = {
  name,
  title,
  tagName: 'em',
  className: null,

  edit(_ref) {
    let {
      isActive,
      value,
      onChange,
      onFocus
    } = _ref;

    function onToggle() {
      onChange(toggleFormat(value, {
        type: name,
        title
      }));
    }

    function onClick() {
      onChange(toggleFormat(value, {
        type: name
      }));
      onFocus();
    }

    return createElement(Fragment, null, createElement(RichTextShortcut, {
      type: "primary",
      character: "i",
      onUse: onToggle
    }), createElement(RichTextToolbarButton, {
      name: "italic",
      icon: formatItalic,
      title: title,
      onClick: onClick,
      isActive: isActive,
      shortcutType: "primary",
      shortcutCharacter: "i"
    }), createElement(__unstableRichTextInputEvent, {
      inputType: "formatItalic",
      onInput: onToggle
    }));
  }

};
//# sourceMappingURL=index.js.map